module.exports = __webpack_public_path__ + "static/img/index-logo2.ebd2b9ff.png";